module.exports = __webpack_public_path__ + "static/media/country.1efcdb9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/select-country-modal/country.png
// module id = 1997
// module chunks = 0